import React from 'react';

const IconWebsite = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1"
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
    className="feather feather-website"
  >
    <title>Website</title>
    <g id="SVGRepo_iconCarrier">
      <rect
        width="18"
        height="18"
        rx="3"
        transform="matrix(1.39071e-07 1 1 -1.39071e-07 3 3)"
        stroke="currentColor"
        strokeWidth="1.056"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></rect>
      <line
        x1="1"
        y1="-1"
        x2="17"
        y2="-1"
        transform="matrix(1 -1.82782e-07 -1.82782e-07 -1 3 8)"
        stroke="currentColor"
        strokeWidth="1.056"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></line>
      <line
        x1="9"
        y1="9"
        x2="9"
        y2="20"
        stroke="currentColor"
        strokeWidth="1.056"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></line>
    </g>
  </svg>
);

export default IconWebsite;
